export function isContainerQuerySelector(property) {
    return property.substring(0, 10) === '@container';
}
//# sourceMappingURL=isContainerQuerySelector.js.map